{
  "tags": "Etiquetas",
  "days": "{0,plural,zero {hoxe},one {onte},other {fai # días}}",
  "unmark": "Marcar como non lido",
  "share_pocket_label": "Gardar en Pocket",
  "no_entries": "Non se atoparon rexistros",
  "more": "Máis",
  "filter": "Filtro",
  "online_count": "Elementos dispoñibles no servidor",
  "offline_count": "Elementos dispoñibles localmente",
  "timestamp": "{0,date} {0,time}",
  "hours": "fai {0,plural,one {1 hora},other {# horas}}",
  "minutes": "fai {0,plural,one {1 minuto},other {# minutos}}",
  "seconds": "fai {0,plural,one {1 segundo},other {# segundos}}",
  "share_wallabag_label": "Gardar en Wallabag",
  "share_wordpress_label": "Compartir en WordPress",
  "share_mail_label": "Compartir por email",
  "share_copy_label": "Copiar ligazón o portapapéis",
  "search_label": "Buscar termo",
  "searchbutton": "Procurar",
  "searchremove": "Agochar búsqueda",
  "refreshbutton": "Actualizar as fontes",
  "settingsbutton": "Configuración",
  "logoutbutton": "Fechar a sesión",
  "loginbutton": "Iniciar sesión",
  "sources": "Fontes",
  "sources_loading": "Cargando as fontes…",
  "no_sources": "Non hai fontes configuradas.",
  "source_add": "Engadir fonte",
  "source_opml": "ou importa dende un ficheiro OPML",
  "source_export": "Exportar fontes",
  "source_edit": "Editar",
  "source_filter": "Filtro",
  "source_menu": "Máis accións",
  "source_browse": "Navegar",
  "source_delete": "Borrar",
  "source_warn": "Realmente queres borrar esta fonte?",
  "source_deleting": "Borrando a fonte…",
  "source_warn_cancel_dirty": "Queres descargar os cambios non gardados?",
  "source_new": "Nova fonte sen gardar",
  "source_title": "Título",
  "source_autotitle_hint": "Deixar en branco pra obter título",
  "source_type": "Tipo",
  "source_save": "Gardar",
  "source_cancel": "Cancelar",
  "source_saving": "Gardando cambios da fonte…",
  "source_last_post": "Última entrada vista",
  "error_session_expired": "A sesión expirou",
  "error_add_source": "Non se puido engadira a fonte:",
  "error_edit_source": "Non se puideron gardar os cambios as fontes:",
  "error_delete_source": "Erro borrando a fonte:",
  "error_load_tags": "Non se puideron cargar as etiquetas:",
  "error_unknown_tag": "Etiqueta descoñecida:",
  "error_unknown_source": "Id de fonte descoñecida:",
  "error_mark_items": "Non se puideron marcar todos os elementos visibéis:",
  "error_mark_item": "Non se puido marcar/desmarcar elemento:",
  "error_star_item": "Non se puido marcar/desmarcar a estrela no elemento:",
  "error_logout": "Non se puido fechar a sesión:",
  "error_loading": "Error cargando:",
  "error_loading_stats": "Non se puideron cargar as estatísticas de navegación:",
  "error_saving_color": "Non se puido cargar a nova cor:",
  "error_refreshing_source": "Non se puideron refrescar as fontes:",
  "error_sync": "Non se puideron sincronizar os últimos cambios do servidor:",
  "error_offline_storage": "Error do almacenamento fora de liña: {0}. Recargar pode axudar. Desactivando uso fora de liña polo momento.",
  "share_twitter_label": "Compartir en Twitter",
  "error_offline_storage_not_available": "Almacenamento fora de liña non dispoñíbel. Asegurase de que o seu navegador {0} soporta IndexedDB API{1} e, se está utilizando un navegador baseado en Google Chrome, que non esté usando selfoss en modo incógnito.",
  "error_invalid_subsection": "Subsección inválida:",
  "error_configuration": "Non se puido cargar a configuración.",
  "error_share_native_abort": "Non se puido compartir o elemento, non tes onde compartilo ou canceláchelo.",
  "error_share_native": "Non se puido compartir o elemento.",
  "info_url_copied": "Copiouse a URL o portapapéis.",
  "close_entry": "Fechar",
  "article_actions": "Accións",
  "article_reading_time": "{0} min lectura",
  "unread": "Non lidos",
  "offline_navigation_unavailable": "Cambiar etiquetas e fontes non está dispoñible no modo fora de liña.",
  "source_go_to_settings": "Abrir a configuración",
  "login_in_progress": "Intentando iniciar sesión…",
  "markread": "Marcar como lido",
  "newest": "Novos",
  "alltags": "Todas as etiquetas",
  "source_saved": "Gardado",
  "source_refresh": "Actualizar esta fonte",
  "tag_change_color_button_title": "Cambiar a cor",
  "login": "Iniciar sesión",
  "login_password": "Contrasinal",
  "sources_refreshed": "Actualizaronse as fontes",
  "star": "Marcar con estrela",
  "starred": "Con estrela",
  "unstar": "Quitar a estrela",
  "next": "Seguinte",
  "share_native_label": "Compartir",
  "share_diaspora_label": "Compartir en Diaspora",
  "share_facebook_label": "Compartir en Facebook",
  "source_comma": "Separado por comas",
  "mark": "Marcar como lido",
  "open_window": "Abrir",
  "load_img": "Cargar imaxes",
  "login_invalid_credentials": "Usuario/contrasinal incorrectos",
  "source_tags": "Etiquetas",
  "source_select": "Por favor, escolle unha fonte",
  "source_pwd_placeholder": "Non cambiou",
  "source_params_loading": "Estanse cargando os parámetros…",
  "sources_leaving_unsaved_prompt": "Queres deixar a configuración con cambios de fonte non gardados?",
  "login_username": "Usuario",
  "entries_loading": "Estanse cargando as entradas…",
  "login_offline": "Almacenamento fora de liña",
  "error": "Ocurriu un erro",
  "error_check_system_logs": "Ocurriu un erro, por favor comproba os rexistros do sistema.",
  "error_unwritable_logs": "Non se puideron escribir os rexistros.",
  "no_title": "Sen título",
  "experimental": "Experimental",
  "error_check_log_file": "Produciuse un erro, por favor comproba o ficheiro de rexistro \"{0}\".",
  "streamerror": "Non hai elementos cargados, recargar?",
  "reload_list": "Recargar lista",
  "app_update": "Selfoss actualizouse, recargue",
  "app_reload": "Recargar",
  "error_unauthorized": "{link_begin}inicia sesión{link_end} para continuar.",
  "login_error_generic": "Non se puido iniciar sesión: {errorMessage}",
  "share_mastodon_label": "Comparte en Mastodon"
}
